import { FETCH_ORGANIZATION, FETCH_ORGANIZATION_SUCCESS, FETCH_ORGANIZATION_FAILER } from './OrganisationActionTypes'


interface IInitialState {
    loading: boolean,
    organisationData: any,
    error: string,
}

const initialState: IInitialState = {
    loading: false,
    organisationData: [],
    error: "",
};
const OrganisationReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_ORGANIZATION:
            return {
                ...state,
                loading: true,
                organizationData: [],
                error: ""
            }
        case FETCH_ORGANIZATION_SUCCESS:
            return {
                ...state,
                loading: false,
                organisationData: action.payload,
                error: ""
            }
        case FETCH_ORGANIZATION_FAILER:
            return {
                ...state,
                loading: false,
                organizationData: [],
                error: action.payload
            }

        default:
            return { ...state, }
    }
}

export default OrganisationReducer;